import { z } from "zod";

export type UUID = string & { __brand: "UUID" };
export const uuidSchema = z.uuid().transform((s): UUID => s as UUID);
